import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthAndACLService } from '../auth_and_acl/authAndACL.service';
import { JwtHelper } from 'angular2-jwt';

@Component({
  selector: 'app-pre-login',
  templateUrl: './pre-login.component.html',
  styleUrls: ['./pre-login.component.css']
})
export class PreLoginComponent implements OnInit {

  constructor(
    private router: Router,
    public authAndACL: AuthAndACLService,
    private route: ActivatedRoute
  ) { }

  salvarIdentificacaoParticipante(): void{
    let jwtHelper: JwtHelper = new JwtHelper();

    this.route.queryParams.forEach((params: Params) => {
      let token = params['t'];
      let tokenDecode = jwtHelper.decodeToken(token);
      localStorage.setItem('tipo_documento', tokenDecode.tipo_documento);
      localStorage.setItem('numero_documento', tokenDecode.numero_documento);
      localStorage.setItem('nome', tokenDecode.nome);
    });

  }

  //Redirecionamento do Pre Login para CAS
  irStatus(recaminho: string):void {
    switch (recaminho) {
      case 'interno':
        this.router.navigate(['/dashboard']);
        break;
      case 'externo':
        this.router.navigate(['/aluno/login']);
        break;
      default:
        this.router.navigate(['/prelogin']);
        break;
    }
  }

  ngOnInit() {
    if(this.authAndACL.logado())
        this.router.navigate(['/meus_documentos']);
        
    this.salvarIdentificacaoParticipante();
  }

}



// WEBPACK FOOTER //
// ./src/app/pre-login/pre-login.component.ts